const $ = jQuery
export default function Search() {

	let inactivityTimeout

	$('.js-live-search-input').on('keyup', function() {
		let value = $(this).val()
		let target = $('.js-live-search-results')

		// Clear the existing timeout if there's any to reset the inactivity timer
		if (inactivityTimeout) {
			clearTimeout(inactivityTimeout)
		}

		// Set the inactivity timeout
		inactivityTimeout = setTimeout(function() {
			$('.js-live-search-loading').addClass('active')
			if (value.length >= 1) {
				const query = async () => {
					const response = await fetch(`/wp-json/wp/v2/search/basic?s=${value}`);
					const results = await response.json();

					target.empty()
					let time = 100
					if (await results.results.length > 0) {
						$.each(results, function(index, value) {
							// setTimeout(function() {
								target.append(value)
							// }, time * index)
						})
					} else {
						target.append('<div class="e-heading e-heading--five e-heading--white">No results found</div>')
					}

					$('.js-live-search-loading').removeClass('active')
				};
					query();
			} else {
				target.empty()
				$('.js-live-search-loading').removeClass('active')
			}
		}, 350)
	})


	// Find the search trigger element and the mobile search wrapper element
	const searchTrigger = document.querySelector('.js-search-trigger')
	const searchWrapper = document.querySelector('.js-search-wrapper')

	if (searchTrigger && searchWrapper) {
		// Add a click event listener to the search trigger
		searchTrigger.addEventListener('click', function() {
			searchWrapper.classList.toggle('active')
			document.querySelector('.js-live-search-input').focus()

			let children = searchTrigger.children
			if (searchWrapper.classList.contains('active')) {
				for (let i = 0; i < children.length; i++) {
					if (children[i].tagName === 'SPAN') {
						children[i].innerHTML = 'Close'
					}
					else if (children[i].tagName === 'ION-ICON') {
						children[i].setAttribute('name', 'close-sharp')
					}
				}
			}
			else {
				for (let i = 0; i < children.length; i++) {
					if (children[i].tagName === 'SPAN') {
						children[i].innerHTML = 'Search'
					}
					else if (children[i].tagName === 'ION-ICON') {
						children[i].setAttribute('name', 'search-sharp')
					}
				}
			}

		})
	}


	// Find the search close element
	const searchClose = document.querySelector('.js-search-close')

	if (searchClose) {
		// Add a click event listener to the search close element
		searchClose.addEventListener('click', function() {
			closeSearch()
		})
	}

	// Check the initial window width
	if (window.innerWidth >= 1280) {
		closeSearch() // Call the closeSearch function to hide the mobile search wrapper
	}

	// Handle window resize with a debounce
	window.addEventListener('resize', debounce(function() {
		if (window.innerWidth >= 1280) {
			closeSearch() // Call the closeSearch function to hide the mobile search wrapper
		}
	}, 150))

	// Function to close the mobile search wrapper
	function closeSearch() {
		if (searchWrapper) {
			// Remove the 'active' class from the mobile search wrapper, triggering the slide up effect by CSS
			searchWrapper.classList.remove('active')
		}
	}

	// Debounce function: Executes the given function after waiting for the specified delay.
	function debounce(func, wait) {
		let timeoutId = null

		return function() {
			if (timeoutId !== null) {
				clearTimeout(timeoutId)
			}

			timeoutId = setTimeout(function() {
				func()
				timeoutId = null
			}, wait)
		}
	}
}
